import { render, staticRenderFns } from "./DFM.vue?vue&type=template&id=245cb77f&scoped=true&"
import script from "./DFM.vue?vue&type=script&lang=js&"
export * from "./DFM.vue?vue&type=script&lang=js&"
import style0 from "./DFM.vue?vue&type=style&index=0&id=245cb77f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245cb77f",
  null
  
)

export default component.exports